import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormikTextField from '../forms/FormikTextField';

const PrimaryCheckboxInput = ({ label, setCheckBox, CheckboxData }) => {
  return (
    <div>
      <FormGroup>
        <FormControlLabel
          control={
            <Checkbox
              checked={CheckboxData}
              color="primary"
              name="checked"
              onChange={() => setCheckBox((CheckboxData) => !CheckboxData)}
            />
          }
          label={label}
        />
      </FormGroup>
      {CheckboxData === false && (
        <div>
          <FormikTextField
            autoFocus
            label="Enter server IP address for A record"
            name="aRecord"
            required
          />
          <FormikTextField
            autoFocus
            label="Enter (sub)Domain name for CNAME record"
            name="cnameRecord"
            required
          />
        </div>
      )}
    </div>
  );
};

export { PrimaryCheckboxInput };
